export const actions = {
  CARTELES_LOAD_REQUESTED: 'CARTELES_LOAD_REQUESTED',
  CARTELES_LOAD_SUCCEEDED: 'CARTELES_LOAD_SUCCEEDED',
  CARTELES_LOAD_FILED: 'CARTELES_LOAD_FILED',

  CARTEL_LOAD_BY_ID_REQUESTED: 'CARTEL_LOAD_BY_ID_REQUESTED',
  CARTEL_LOAD_BY_ID_SUCCEEDED: 'CARTEL_LOAD_BY_ID_SUCCEEDED',
  CARTEL_LOAD_BY_ID_FILED: 'CARTEL_LOAD_BY_ID_FILED',

  CARTEL_UPDATE_REQUESTED: 'CARTEL_UPDATE_REQUESTED',
  CARTEL_UPDATE_SUCCEEDED: 'CARTEL_UPDATE_SUCCEEDED',
  CARTEL_UPDATE_FILED: 'CARTEL_UPDATE_FILED',

  CARTEL_INSERT_REQUESTED: 'CARTEL_INSERT_REQUESTED',
  CARTEL_INSERT_SUCCEEDED: 'CARTEL_INSERT_SUCCEEDED',
  CARTEL_INSERT_FILED: 'CARTEL_INSERT_FILED',

  CARTEL_DELETE_REQUESTED: 'CARTEL_DELETE_REQUESTED',
  CARTEL_DELETE_SUCCEEDED: 'CARTEL_DELETE_SUCCEEDED',
  CARTEL_DELETE_FILED: 'CARTEL_DELETE_FILED',
}

export const getCartelesAction = dispatch => {
  dispatch({
    type: actions.CARTELES_LOAD_REQUESTED,
  })
}

export const getCartelByIdAction = (dispatch, id) => {
  dispatch({
    type: actions.CARTEL_LOAD_BY_ID_REQUESTED,
    payload: id,
  })
}

export const onSubmitInsertCartelFormAction = (dispatch, formCartel) => {
  dispatch({
    type: actions.CARTEL_INSERT_REQUESTED,
    payload: formCartel,
  })
}

export const onSubmitUpdateCartelFormAction = (dispatch, formCartel) => {
  dispatch({
    type: actions.CARTEL_UPDATE_REQUESTED,
    payload: formCartel,
  })
}

export const deleteCartelAction = (dispatch, id) => {
  dispatch({
    type: actions.CARTEL_DELETE_REQUESTED,
    payload: id,
  })
}
